import './style.scss';
import React from 'react';
import Toggle from 'react-toggle';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import SkillSelector from './SkillSelector';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class MembersFreelancer extends React.Component {
  render() {
    let { membersStore, member, intl } = this.props;
    let { confirm } = membersStore;
    return (
      <Row>
        <Col sm={6}>
          {!membersStore.canManage ? null : (
            <div className="toggle-container">
              <label>
                <h5>{intl.formatMessage({ id: 'customer_support' })}</h5>
              </label>
              <br />
              <Toggle
                checked={member.customer_support_leader}
                onChange={e => {
                  if (confirm())
                    membersStore.handleCustomerSupport(
                      member.id,
                      !member.customer_support_leader,
                    );
                }}
              />
            </div>
          )}
        </Col>
        <Col sm={6}>
          <SkillSelector member={member} />
        </Col>
      </Row>
    );
  }
}
